'use strict';

function BigCheckboxes() {

    this.initCheckboxes = function () {
        this.setReplacementCheckboxes();
    };

    /********************************/
    // set checkboxes
    /********************************/
    this.setReplacementCheckboxes = function () {
        var glyphiconYesClass = 'glyphicon-ok';
        var glyphiconNoClass = 'glyphicon-none';
        var textYesClass = 'text-success';
        var textNoClass = '';
        var newCheckboxClass = 'big-checkbox';

        $('#sta-abroad-programme-choices').find('input[type="checkbox"]').each(function () {
            $(this)
                .hide()
                .after($(this).is(':checked') ? '<span data-checkbox-id="#' + $(this).attr('id') + '" class="' + newCheckboxClass + ' glyphicon ' + glyphiconYesClass + ' ' + textYesClass + '">' +
                    '</span>' : '<span data-checkbox-id="#' + $(this).attr('id') + '" class="' + newCheckboxClass + ' glyphicon ' + glyphiconNoClass + ' ' + textNoClass + '"></span>');
        });

        $('.big-checkbox').click(function () {
            var $checkbox = $(this).siblings('input[type="checkbox"]');
            $checkbox.prop('checked', !$(this).hasClass(glyphiconYesClass));
            $(this).toggleClass(glyphiconYesClass + ' ' + glyphiconNoClass).toggleClass(textYesClass + ' ' + textNoClass);
        });
    };
}
